/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as m } from "../../chunks/jsx-runtime.BwWtxLpl.js";
import s from "react";
import { d as l } from "../../chunks/index.esm.eyITaPoj.js";
import { a as n } from "../../chunks/index.B5J4Cqi6.js";
import "../../chunks/currency-utils.DnRSwher.js";
import f from "../../hooks/useFormCurrency.js";
const j = ({ name: a, type: o, render: t }) => {
  const { field: r } = l({ name: a }), { formatValue: e } = f(), u = s.useMemo(() => o ? o === "currency" ? e(r.value) : n(o, r.value) : r.value, [r.value, e, o]);
  return t ? t(r.value, u) : /* @__PURE__ */ m.jsx("span", { children: u });
};
export {
  j as default
};
